<template>
  <section class="news-detail-content">
    <div class="main">
      <div class="first">
        <h3>{{title}}</h3>
        <div class="info">{{postedOn_}} <span>{{formatTime(timestamp)}}</span></div>
        <div class="content" v-html="trustedContent"></div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  import marked from 'marked'

  import { news } from '@/utils/api.js'
  import { formatTime } from '@/utils'
  import i18n from '@/i18n'

  const findNews = (news, id) => {
    for (let i of news) {
      if (i.id === id) return i
    }
  }

  export default {
    data () {
      return {
        title: '',
        content: '',
        timestamp: 0
      }
    },
    computed: {
      ...mapState(['v_locale']),
      ...mapGetters(['gameOver']),
      ...i18n.map(['postedOn_']),
      trustedContent () {
        return marked(this.content)
      }
    },
    methods: {
      ...mapMutations([]),
      ...mapActions([]),
      formatTime
    },
    created () {
      const nid = this.$route.params.nid
      news()
        .then((data) => {
          if (!data.data) {
            return
          }
          const news = findNews(data.data, nid)
          this.content = news.content
          this.title = news.title
          this.timestamp = news.update_time
        })
        .catch((err) => {
          this.$emit('msg', {
            msg: err.message,
            type: 'error',
            delay: 2000
          })
        })
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/news_detail.vue